// Calendar dates in the user's local time zone. Boundaries are inclusive.
const SEASON_START = { month: 11, day: 15 };
const SEASON_END = { month: 1, day: 10 };

export const isSecretSantaSeason = (date = new Date()): boolean => {
  const current = (date.getMonth() + 1) * 100 + date.getDate();
  const start = SEASON_START.month * 100 + SEASON_START.day;
  const end = SEASON_END.month * 100 + SEASON_END.day;
  return start <= end
    ? current >= start && current <= end
    : current >= start || current <= end;
};
